module.exports = __webpack_public_path__ + "static/media/country_ag.dc5cb514.webp";